export type ContactPhoneEntry = {
  display: string;
  tel: string;
  hint?: string;
  whatsappPhone?: string;
};

export const RCR_CONTACT_PHONES: ContactPhoneEntry[] = [
  {
    display: '0800 866 1616',
    tel: '08008661616',
    hint: '(Demais regiões)',
    whatsappPhone: '558007010123',
  },
  {
    display: '4003 1616',
    tel: '40031616',
    hint: '(Capitais e regiões metropolitanas)',
    whatsappPhone: '558007010123',
  },
];

export const DEFAULT_RCR_WHATSAPP_PHONE =
  RCR_CONTACT_PHONES[0].whatsappPhone ?? '558007010123';
